import { useUserInformationContext } from 'contexts/userContext';
import { useTranslation } from 'react-i18next';

const useAccessRequired = () => {
  const { currentUser } = useUserInformationContext();
  const { t } = useTranslation();
  const isAdmin = currentUser?.is_admin;
  return { isAdmin, t, routes: currentUser?.allowedRoutes };
};

export default useAccessRequired;
